import { faWrench } from '@fortawesome/pro-regular-svg-icons';
import { useMaintenanceMode } from '@quality24/react-maintenance-mode';
import { Icon, Image, Text } from '@quality24/design-system';
import classNames from 'classnames';
import React from 'react';
import styles from './MaintenanceMode.module.scss';
import logo from './logo_white.png';

export interface Props {
  className?: string;
}

const MaintenanceMode: React.FunctionComponent<Props> = ({ className }) => {
  const { isEnabled } = useMaintenanceMode();

  return isEnabled ? (
    <div className={classNames(className, styles.wrapper)}>
      <div className={styles.header}>
        <Image src={logo} alt="Logo Quality 24" />
      </div>
      <div className={styles.content}>
        <div>
          <Icon icon={faWrench} size="xl" />
          <Text weight="bold" size="lg1">
            Este serviço está em manutenção.
          </Text>
          <Text size="lg1">Por favor, aguarde para utilizá-lo.</Text>
        </div>
      </div>
    </div>
  ) : null;
};

export default MaintenanceMode;
